import React from 'react'
import { compose } from 'redux'
import { prismicRichTextAsHTML } from 'prismic-utils'
import { withInjectURLParams } from '../../utils/InjectURLParams'
import renderEmbedHtml from '../../../lib/embedHtml'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import BaseRichText from 'constructicon/rich-text'

const RichText = ({
  classNames,
  children,
  injectURLParams,
  styles,
  ...props
}) => {
  const html = typeof children === 'object'
    ? prismicRichTextAsHTML(children.map(serializeElement))
    : children

  return (
    <BaseRichText styles={styles.root} {...props}>
      {injectURLParams(html)}
    </BaseRichText>
  )
}

const serializeElement = item => {
  if (item.type === 'embed' && item.oembed) {
    return {
      ...item,
      oembed: {
        ...item.oembed,
        html: renderEmbedHtml(item.oembed)
      }
    }
  }

  return item
}

export default compose(
  withInjectURLParams,
  withStyles(styles)
)(RichText)



// WEBPACK FOOTER //
// ./components/ui/RichText/index.js